var _g, _tspan, _g2, _g3, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysicalBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 235 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "axis"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0051,0,0,1.0051,-146.214,-284.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.92,350.334L363.949,350.334",
    style: {
      fill: "none",
      stroke: "black",
      strokeOpacity: 0.05,
      strokeWidth: "0.99px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-877.16,-66.597)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13,0,0,13,1095.64,150.104)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "1059.3px",
    y: "150.104px",
    style: {
      fontFamily: "'Aileron-Regular', 'Aileron'",
      fontSize: 13,
      fill: "rgb(183,183,183)"
    }
  }, "T", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "1066.45px ",
    y: "150.104px "
  }, "o")), "day")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-989.296,-104.452)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13,0,0,13,1074.72,186.377)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "1003.97px",
    y: "186.377px",
    style: {
      fontFamily: "'Aileron-Regular', 'Aileron'",
      fontSize: 13,
      fill: "rgb(183,183,183)"
    }
  }, "90 days ago"))), /*#__PURE__*/React.createElement("g", {
    id: "physical-BEFORE",
    transform: "matrix(1,0,0,1,0.324336,4.81514)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1085.35,-215.033)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15,0,0,15,1303.25,243.961)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "1268.22px",
    y: "243.961px",
    style: {
      fontFamily: "'Aileron-Black', 'Aileron'",
      fontWeight: 900,
      fontSize: 15,
      fill: "rgb(255,152,0)"
    }
  }, "F", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "1277.25px 1288.08px 1293.02px ",
    y: "243.961px 243.961px 243.961px "
  }, "AIR")))), /*#__PURE__*/React.createElement("g", {
    id: "physical_operations",
    transform: "matrix(1.79293,0,0,1.45026,-271.913,-444.424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.612,335.386C159.612,335.386 208.373,332.478 228.855,331.793C245.143,331.249 259.925,334.899 272.538,335.101",
    style: {
      fill: "none",
      stroke: "rgb(255,152,0)",
      strokeWidth: "1.75px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalBefore);
export default __webpack_public_path__ + "static/media/physical-before.e5ca2f443eb4e88a55f4d7897c8746e5.svg";
export { ForwardRef as ReactComponent };